import 'prosemirror-state';
import 'prosemirror-model';
import 'uuid';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function (className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
// 获取浏览器和系统信息
function getSystemInfo() {
    // browser
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browser = navigator.appName;
    var version = "".concat(parseFloat(navigator.appVersion));
    var nameOffset;
    var verOffset;
    var ix;
    var isMobile = nAgt.toLowerCase().indexOf("mobile") !== -1;
    // Opera
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 6);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Opera Next
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf("OPR")) !== -1) {
        browser = "Opera";
        version = nAgt.substring(verOffset + 4);
        // Edge
        // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Edge")) !== -1) {
        browser = "Microsoft Edge";
        version = nAgt.substring(verOffset + 5);
        // MSIE
        // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(verOffset + 5);
        // Chrome
        // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browser = "Chrome";
        version = nAgt.substring(verOffset + 7);
        // Safari
        // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browser = "Safari";
        version = nAgt.substring(verOffset + 7);
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf("Version")) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
        // Firefox
        // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browser = "Firefox";
        version = nAgt.substring(verOffset + 8);
        // MSIE 11+
    } else if (nAgt.indexOf("Trident/") !== -1) {
        browser = "Microsoft Internet Explorer";
        version = nAgt.substring(nAgt.indexOf("rv:") + 3);
        // Other browsers
    } else if (// eslint-disable-next-line no-cond-assign
        (nameOffset = nAgt.lastIndexOf(" ") + 1) < // eslint-disable-next-line no-cond-assign
        (verOffset = nAgt.lastIndexOf("/"))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(";")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(" ")) !== -1) {
        version = version.substring(0, ix);
    }
    // eslint-disable-next-line no-cond-assign
    if ((ix = version.indexOf(")")) !== -1) {
        version = version.substring(0, ix);
    }
    // system
    var os = "unknown";
    var clientStrings = [
        {
            s: "Windows 10",
            r: /(Windows 10.0|Windows NT 10.0)/
        },
        {
            s: "Windows 8.1",
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        {
            s: "Windows 8",
            r: /(Windows 8|Windows NT 6.2)/
        },
        {
            s: "Windows 7",
            r: /(Windows 7|Windows NT 6.1)/
        },
        {
            s: "Windows Vista",
            r: /Windows NT 6.0/
        },
        {
            s: "Windows Server 2003",
            r: /Windows NT 5.2/
        },
        {
            s: "Windows XP",
            r: /(Windows NT 5.1|Windows XP)/
        },
        {
            s: "Windows 2000",
            r: /(Windows NT 5.0|Windows 2000)/
        },
        {
            s: "Windows ME",
            r: /(Win 9x 4.90|Windows ME)/
        },
        {
            s: "Windows 98",
            r: /(Windows 98|Win98)/
        },
        {
            s: "Windows 95",
            r: /(Windows 95|Win95|Windows_95)/
        },
        {
            s: "Windows NT 4.0",
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        {
            s: "Windows CE",
            r: /Windows CE/
        },
        {
            s: "Windows 3.11",
            r: /Win16/
        },
        {
            s: "Android",
            r: /Android/
        },
        {
            s: "Open BSD",
            r: /OpenBSD/
        },
        {
            s: "Sun OS",
            r: /SunOS/
        },
        {
            s: "Linux",
            r: /(Linux|X11)/
        },
        {
            s: "iOS",
            r: /(iPhone|iPad|iPod)/
        },
        {
            s: "Mac OS X",
            r: /Mac OS X/
        },
        {
            s: "Mac OS",
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        {
            s: "QNX",
            r: /QNX/
        },
        {
            s: "UNIX",
            r: /UNIX/
        },
        {
            s: "BeOS",
            r: /BeOS/
        },
        {
            s: "OS/2",
            r: /OS\/2/
        },
        {
            s: "Search Bot",
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }
    var osVersion = "unknown";
    if (/Windows (.*)/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = "Windows";
    }
    switch (os) {
        case "Mac OS X":
            if (/Mac OS X ([._\d]+)/.test(nAgt)) {
                osVersion = /Mac OS X ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "Android":
            if (/Android ([._\d]+)/.test(nAgt)) {
                osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            }
            break;
        case "iOS":
            if (/OS (\d+)_(\d+)_?(\d+)?/.test(nVer)) {
                var splits = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits[1], ".").concat(splits[2], ".").concat(+splits[3] | 0);
            } else if (/iOS\/(\d+).(\d+).?(\d+)?/.test(nVer)) {
                var splits1 = /iOS\/(\d+).(\d+).?(\d+)?/.exec(nVer);
                // eslint-disable-next-line no-bitwise
                osVersion = "".concat(splits1[1], ".").concat(splits1[2], ".").concat(+splits1[3] | 0);
            }
            break;
    }
    return {
        browser: browser || "unknown",
        browserVersion: version || "unknown",
        os: os || "unknown",
        osVersion: osVersion || "unknown",
        isMobile: isMobile,
        isWindows: ~(os || "unknown").toLowerCase().indexOf("win")
    };
}

// dpi=1.25时，表格宽度需要为 4 的整数倍
var formatWidth = function (width) {
    // width = Math.round(width);
    // width = Math.round(width / 4) * 4;
    return width;
};

function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var getColWidth = function (attr) {
    if (!attr) return undefined;
    return attr.split(",").reduce(function (p, c) {
        return +p + +c;
    }, 0);
};
/**
 * 计算表格总宽度
 * 及判断表格是否存在宽度信息
 */ var calculateTableWidth = function (tr) {
    var tableWidth = 0;
    var allHasWidth = true;
    Array.from(tr).forEach(function (td) {
        if (!_instanceof(td, HTMLElement)) return;
        if (!td.getAttribute("data-colwidth") || td.getAttribute("data-colwidth") === "0") {
            allHasWidth = false;
        } else {
            var width = getColWidth(td.getAttribute("data-colwidth"));
            // 处理存在 colspan>1 但是 data-colwidth只有一个值 而非 data-colwidth='68,68,68'的形式
            var colspan = td.getAttribute("colspan");
            var dataWidth = td.getAttribute("data-colwidth");
            var dataLen = (dataWidth || "").split(",").length;
            if (dataLen === 1 && colspan && +colspan > 1) {
                width = +colspan * +dataWidth;
            }
            if (window.devicePixelRatio === 1.25) {
                width = formatWidth(width);
            }
            tableWidth += width;
        }
    });
    return {
        tableWidth: tableWidth,
        allHasWidth: allHasWidth
    };
};
// table中插入 colgroup 标签
function addColGroup(table) {
    if (Array.from(table.children).some(function (ele) {
        return (ele.tagName || "").toLowerCase() === "colgroup";
    })) {
        return;
    }
    var tbodyChild = table.getElementsByTagName("tbody")[0];
    if (!tbodyChild) {
        return;
    }
    var firstTr = tbodyChild.childNodes[0];
    if (!firstTr) return;
    var colgroup = document.createElement("colgroup");
    Array.from(firstTr.childNodes).forEach(function (td) {
        if (!_instanceof(td, HTMLElement)) return;
        var colspan = td.getAttribute("colspan");
        var colwidth = td.getAttribute("data-colwidth");
        var widthArr = colwidth && colwidth.split(",") || [];
        if (colspan) {
            for (var i = 0; i < +colspan; i++) {
                var col = document.createElement("col");
                var width = widthArr && widthArr[i];
                width = +width;
                if (width) {
                    if (window.devicePixelRatio === 1.25) {
                        width = formatWidth(width);
                    }
                    col.setAttribute("style", "width: ".concat(width, "px;"));
                }
                colgroup.appendChild(col);
            }
        } else {
            var col1 = document.createElement("col");
            if (+colwidth) {
                if (window.devicePixelRatio === 1.25) {
                    colwidth = formatWidth(+colwidth);
                }
                col1.setAttribute("style", "width: ".concat(colwidth, "px;"));
            }
            colgroup.appendChild(col1);
        }
    });
    table.insertBefore(colgroup, table.childNodes[0]);
}
// 处理窗口放大情况下的表格宽度处理
function translateWidthForScaleWindow(td, originTds, index) {
    td.forEach(function (i, ind) {
        var width = getColWidth(i.getAttribute("data-colwidth"));
        width = formatWidth(width);
        var originTd = originTds && originTds[ind];
        if (width) {
            if (index === 0) {
                i.style.cssText = "".concat(i.style.cssText, " min-width: ").concat(width, "px; max-width: ").concat(width, "px;");
            }
            i.setAttribute("width", "".concat(width, "px"));
            return;
        }
        // 解决表头吸顶无宽度
        var clientWidth = originTds && originTd ? originTd.clientWidth : i.clientWidth;
        clientWidth += 18;
        clientWidth = formatWidth(clientWidth);
        if (clientWidth < 52) clientWidth = 52;
        if (index === 0) {
            i.setAttribute("width", "".concat(clientWidth, "px"));
            i.style.cssText = "".concat(i.style.cssText, " min-width: ").concat(clientWidth, "px; max-width: ").concat(clientWidth, "px;");
        } else {
            i.setAttribute("width", "".concat(clientWidth, "px"));
        }
    });
}
// 将表头的 data-colwidth 转成 width
function translateWidth(table, originTable) {
    var tableInCollapse = originTable && originTable.closest(".ct-collapse-content");
    var tableLayout = table.getAttribute("data-table-layout");
    // 展开宏内表格自适应宽度的情况 需要先展开宏展开进行宽度计算 否则获取不到正确宽度
    if (tableInCollapse && tableLayout && tableLayout === "auto") {
        tableInCollapse.style.display = "block";
    }
    Array.from(table.querySelectorAll("tr")).forEach(function (tr, index) {
        var tds = tr.querySelectorAll("th, td");
        if (!tds) return;
        var originTrs = originTable && originTable.querySelectorAll("tr");
        var originTds = originTrs && originTrs[index] && originTrs[index].querySelectorAll("th, td");
        // 解决 windows 下显示默认125%的缩放
        if (window.devicePixelRatio === 1.25) {
            translateWidthForScaleWindow(tds, originTds, index);
            return;
        }
        Array.from(tds).forEach(function (td, ind) {
            var width = getColWidth(td.getAttribute("data-colwidth"));
            // 将表格行号列转成真实的数据，以便排序
            var isNumCell = td.classList.contains("num-cell");
            var isMobile = getSystemInfo().isMobile;
            if (isNumCell && !isMobile) {
                td.classList.add("num-cell-view");
            }
            // 在需要设置overflow的地址设置 避免所有都设置overflow属性 导致大文档加载卡死
            var needOverFlow = td.querySelector('a[class="ct-attachment"]') || td.querySelector(".ct-status");
            var originTd = originTds && originTds[ind];
            if (width) {
                if (index === 0) {
                    td.style.cssText = "".concat(td.style.cssText, " min-width: ").concat(width, "px; max-width: ").concat(width, "px; width: ").concat(width, "px;");
                }
                td.setAttribute("width", "".concat(width, "px"));
                if (needOverFlow) td.style.overflow = "hidden";
                return;
            }
            // 解决表头吸顶无宽度
            var clientWidth = originTds && originTd ? originTd.clientWidth : td.clientWidth;
            clientWidth += 18; // 原始宽度没有 padding 需要加上 padding
            if (clientWidth < 50) clientWidth = 50;
            td.setAttribute("width", "".concat(clientWidth, "px"));
            if (needOverFlow) td.style.overflow = "hidden";
            td.style.cssText = "".concat(td.style.cssText, " min-width: ").concat(clientWidth, "px; max-width: ").concat(clientWidth, "px;");
        });
    });
    if (tableInCollapse && tableLayout && tableLayout === "auto") {
        tableInCollapse.style.display = "none";
    }
}
// 添加表格表框解决表格表框 丢失一部分或者 粗细只有一半
function addTableBorder(table) {
    var _table_dataset = table.dataset, bordercolor = _table_dataset.bordercolor, borderwidth = _table_dataset.borderwidth, borderstyle = _table_dataset.borderstyle;
    if (borderwidth === "0") return;
    var borderCSS = "".concat(borderwidth || 1, "px ").concat(borderstyle || "solid", " ").concat(bordercolor || "#cccccc");
    table.style.borderTop = borderCSS;
    if (borderwidth) {
        table.style.borderLeft = borderCSS;
    }
}

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = ".ct-table-view{display:block;overflow-x:auto;overflow-y:hidden;margin:24px 0 8px;padding-bottom:1px;padding-right:1px;counter-reset:cellnumber}.ct-table-view table,.ct-table-view tbody,.ct-table-view td,.ct-table-view th{background-clip:padding-box!important}.ct-table-view table{width:auto;border-collapse:collapse;table-layout:fixed;word-break:break-all;position:relative;overflow:auto;margin:0}.ct-table-view td,.ct-table-view th{box-sizing:border-box;width:auto;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;padding:1px 8px;border:1px solid #ddd;vertical-align:top;background-color:#fff;outline:none;position:relative}.ct-table-view td.overflow,.ct-table-view th.overflow{overflow:hidden;position:relative}.ct-table-view td>ol,.ct-table-view td>ul,.ct-table-view th>ol,.ct-table-view th>ul{overflow:hidden}.ct-table-view th{text-align:left;background-color:#f6f6f6;overflow:hidden}.ct-table-view td{overflow:hidden}.ct-table-view table td>p>span.ct-node-view-dom,.ct-table-view table th>p>span.ct-node-view-dom{margin:0 0 0 -3px}.ct-table-view table.responsive>tbody>tr>td,.ct-table-view table.responsive>tbody>tr>th{width:auto!important;min-width:52px}.ct-table-view .num-cell{counter-increment:cellnumber;vertical-align:top;text-align:center;color:#000;padding:8px 0;font-size:12px;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ct-table-view .num-cell:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;content:counter(cellnumber)}.ct-table-view .num-cell p{display:none}.ct-table-view h1,.ct-table-view h2,.ct-table-view h3,.ct-table-view h4,.ct-table-view h5,.ct-table-view h6,.ct-table-view p{min-width:0;margin-top:8px}.ct-table-view ol,.ct-table-view ul{padding-left:34px}";
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

// 更新阴影的显示和隐藏
function updateTableShadows(container, leftShadow, rightShadow) {
    var containerRect = container.getBoundingClientRect();
    var lastChild = container.lastElementChild;
    var lastChildRect = lastChild.getBoundingClientRect();

    leftShadow.style.visibility = container.scrollLeft > 0 ? 'visible' : 'hidden';
    rightShadow.style.visibility = lastChildRect.right <= containerRect.right ? 'hidden' : 'visible';
}

// 检查表格是否有滚动条并更新阴影状态
function checkForScrollbarAndSetShadows(node, leftShadow, rightShadow) {
    // 检查是否有水平滚动条
    var hasScrollbar = node.style.width.split('px')[0] > 1209;
    // 如果有滚动条，则默认显示右侧阴影
    rightShadow.style.visibility = hasScrollbar ? 'visible' : 'hidden';
    // 左侧阴影默认不显示，因为初始滚动位置是0
    leftShadow.style.visibility = 'hidden';
}

var tableRender = function tableRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, tableRender);
    this.fragmentRender = function (node) {
        if (!node.querySelector("tr")) return; // 过滤空表格
        if (node.parentNode.classList.contains(classNamePrefix("table-view"))) {
            return;
        }
        // 为 table 多加一层 <div class='ct-table-view'>...</div>
        var newNode = document.createElement("div");
        newNode.setAttribute("class", classNamePrefix("table-view"));
        node.parentNode.insertBefore(newNode, node);
        newNode.appendChild(node);
        var hasMargin = node.style.marginLeft;
        if (hasMargin) {
            node.parentNode.style.marginLeft = hasMargin;
            node.parentNode.style.marginRight = "1px"; // 使得滚动到最右侧能显示边框
            node.parentNode.style.width = "calc(100% - ".concat(parseInt(hasMargin, 10) + 1, "px)");
            node.style.marginLeft = 0;
        }
        var isResponsive = node.classList.contains("responsive");
        var tr = node.querySelectorAll("tr");
        var trLen = tr && tr.length === 1;
        var tableLayout = node.getAttribute("data-table-layout");
        if (!isResponsive) {
            // 计算table总宽度
            var tablechild = node.querySelector("tr:first-child").childNodes;
            var _calculateTableWidth = calculateTableWidth(tablechild), tableWidth = _calculateTableWidth.tableWidth, allHasWidth = _calculateTableWidth.allHasWidth;
            if (allHasWidth && !node.hasAttribute("width")) {
                node.style.width = "".concat(tableWidth, "px");
            }
            if (!allHasWidth && !node.hasAttribute("min-width") && tableWidth) {
                node.style.minWidth = "".concat(tableWidth, "px");
            }
            addColGroup(node);
            // 仅有一个表头且表格为自适应宽度的不需要转换宽度
            if (trLen && tableLayout === "auto") return;
            translateWidth(node);
        }
        addTableBorder(node);

        // 为 table 多加一层 <div class='ct-table-view'>...</div>
        var tableContainer = document.createElement("div");
        tableContainer.setAttribute("class", classNamePrefix("table-container"));
        newNode.parentNode.insertBefore(tableContainer, newNode);
        tableContainer.appendChild(newNode);

        // 添加阴影元素
        var mountedContainer = document.createElement("div");
        mountedContainer.setAttribute("class", classNamePrefix("mounted-container"));
        tableContainer.appendChild(mountedContainer);

        var leftShadow = document.createElement("div");
        leftShadow.className = classNamePrefix("table-shadow-left");
        var rightShadow = document.createElement("div");
        rightShadow.className = classNamePrefix("table-shadow-right");
        mountedContainer.appendChild(leftShadow);
        mountedContainer.appendChild(rightShadow);

        // 检查是否有滚动条并设置阴影
        checkForScrollbarAndSetShadows(node, leftShadow, rightShadow);

        // 监听滚动事件来更新阴影的显示和隐藏
        newNode.addEventListener('scroll', function () {
            updateTableShadows(newNode, leftShadow, rightShadow);
        });
    };
    this.fragmentCls = "table";
    this.config = config;
};

export default tableRender;
//# sourceMappingURL=render.js.map
